
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pro/assistance",
      function () {
        return require("private-next-pages/pro/assistance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pro/assistance"])
      });
    }
  